import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const PromotionSale = t0 => {
  const $ = _c(7);
  const {
    displayValue,
    textColor
  } = t0;
  let t1;
  if ($[0] !== textColor) {
    t1 = <span className="text-[#dbeded]" style={{
      color: textColor
    }}> Ends in </span>;
    $[0] = textColor;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== displayValue) {
    t2 = displayValue.map(_temp);
    $[2] = displayValue;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <span className="flex flex-row items-center justify-start min-w-[200px] max-[767px]:inline max-[767px]:min-w-[auto] max-[767px]:mt-[5px]">{t1}{t2}</span>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
PromotionSale.propTypes = {
  displayValue: PropTypes.arrayOf(PropTypes.array),
  textColor: PropTypes.string
};
export default PromotionSale;
function _temp(t0, valueIndex) {
  const [value, unit] = t0;
  return <span className="bg-brand-lighter rounded-[3px] text-[#163a3e] mx-[.2rem] my-0 px-[7px] py-0 max-[767px]:items-baseline max-[767px]:inline-flex" key={valueIndex}><span className="text-base font-bold relative -top-px">{value}</span><span className="text-xs font-bold ml-0.5 relative -top-px">{unit}</span></span>;
}